import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react'
import { MiaBrand } from '../components/MiaBrand'

type State = {
  failed: boolean
  errorId: string
}

export class ApplicationErrorBoundary extends Component<PropsWithChildren, State> {
  override state: State = { failed: false, errorId: '' }

  static getDerivedStateFromError(): State {
    return { failed: true, errorId: crypto.randomUUID() }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('mia_every_ui_unhandled_error', {
      errorId: this.state.errorId,
      message: error.message,
      componentStack: info.componentStack,
    })
  }

  override render(): ReactNode {
    if (!this.state.failed) {
      return this.props.children
    }
    return (
      <main className="application-error-shell">
        <section className="application-error-card">
          <MiaBrand product="Enterprise AI" />
          <span className="eyebrow">CONTINUIDADE OPERACIONAL</span>
          <h1>Não foi possível carregar esta tela</h1>
          <p>A sessão foi preservada. Recarregue a aplicação para tentar novamente.</p>
          <button className="primary-button" type="button" onClick={() => window.location.reload()}>Recarregar aplicação</button>
          <small>Código de correlação: {this.state.errorId}</small>
        </section>
      </main>
    )
  }
}
